<template>
  <segment-page></segment-page>
</template>

<script>
import SegmentPage from '@/modules/audiences/pages/SegmentPage'
export default {
  name: 'SegmentCopyPage',
  components: { SegmentPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SegmentPageCopy.vue